import React from 'react';
import Container, { Props } from './container';
import Style from './index.less';
import classnames from 'classnames/bind';

export default function Wrapper(props: Props) {
  const $c = classnames.bind(Style);
  return <Container {...props} $c={$c}></Container>;
}
